<template>
    <div class="recordWrap">
        <!-- <div class="recordHeader">
            <Heads isBack="true">
                <slot>
                    <h2>投放记录</h2>
                </slot>
            </Heads>
        </div> -->
        <div class="record_content">
            <Loading v-if="showTask"></Loading>
            <div class="record_list" v-for="(val,index) in listData" :key="index">
                <div class="list_left">
                    <div class="record_img">
                        <img :src="val.headimgurl" alt="">
                    </div>
                    <div class="record_msg">
                        <h3 v-if="val.nickname!=''">{{val.nickname}}</h3>
                        <h3 v-else></h3>
                        <p>{{val.tel}}</p>
                    </div>
                </div>
                <div class="list_right">
                    <i :class="['iconfont','icon-dibudianhua',top?'isTop':'']" @click="toPhone(val)"></i>
                    <i class="iconfont icon-dibuxinxi" @click="toUser(val)"></i>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Heads from "@/components/heads.vue"
import { MessageBox } from 'mint-ui'
import Loading from '@/components/Loading.vue'
import qs from 'qs'
export default {
    name: "record",
    data(){
       return{
           listData:[], //当前数据
           top:false, //是否开通转店快
           depthbomb_id: null, //获取path上的id
           showTask: false, //是否显示loading
           shop_id: null, //shop_id
       }
    },
    components:{
        Heads,
        Loading
    },
    methods: {
        getData(){
            this.showTask = true
            this.ajax.get(this.globalData.serverSrc+'/app/depthbomb/log?depthbomb_id='+this.depthbomb_id).then(res=>{
                var res = res.data
                this.showTask = false
                if(res.status == 1 && res.data.code == 1){
                    this.listData = res.data.lists
                    this.top = res.data.top
                    this.shop_id = res.data.shop_id
                }else{
                    this.$toast({
                        message: res.note,
                        position: 'middle',
                        duration: 2000
                    })
                }
            })
        },
        // 点击去聊天
        toUser(val){
            console.log(val)
             var uagent=navigator.userAgent;
            var isLepu=false;
            // uagent = 'appType/app_h5_android_4.3.30'
            var uamatch=uagent.match(/appType\/app_h5_(.*)/);
            var app_str,app_info,app_info_len,isLepuAndroid,isLepuIos,lepuVersion;

            if(uamatch){
                isLepu=true;
                app_str=uamatch[1];

                app_info=app_str.split('_');
                app_info_len=app_info.length;
                if(app_info_len>0){
                    if(app_info.length==2){
                        if(app_info[0] == 'android'){
                            isLepuAndroid=true;
                        }else if(app_info[0] == 'ios'){
                            isLepuIos=true;
                        }
                        lepuVersion=app_info[1];

                    }else if(app_info.length==1){
                        if(app_info[0] == 'android'){
                            isLepuAndroid=true;
                        }else if(app_info[0] == 'ios'){
                            isLepuIos=true;
                        }

                    }
                }
                
            }
            if(isLepu){
                var arg='{"act":"open_chat","imuser":"'+val.to_user+'"}';

                if(localStorage.getItem('istype')=='android'){
                    android.postMessage(arg);
                }else{
                    window.webkit.messageHandlers.appRun.postMessage(arg)
                }
            }else{
                MessageBox({
                    message: '请在乐铺APP内联系对方',
                    confirmButtonText: '去下载',
                    callback :action=>{
                        location.href = '//m.lepu.cn/app/down'
                    }
                })
            }
        },
        // 点击拨打电话
        toPhone(val){
            if(!this.top){
                MessageBox({
                    message: '开通转店快可拨打全部电话，是否开通？',
                    confirmButtonText: '立即开通',
                    showCancelButton: true,
                    cancelButtonText: '取消',
                    callback:action=>{
                        if(action == 'confirm'){
                            location.href="//m.lepu.cn/activity/quick-transfer"
                        }
                    }
                })
            }else{
                this.ajax.post('//api.lepu.cn/app/report/see-mobile',qs.stringify({id:this.shop_id,to_user:val.to_user})).then(res=>{
                    if(res.data.status == 1 && res.data.data.code == 1 ){
                        window.location.href = 'tel:' + res.data.data.tel
                    }else{
                        this.$toast({
                            message: res.data.note,
                            position: 'middle',
                            duration: 2000
                        })
                    }
                })
            }
        }
    },
    created(){
        if(JSON.stringify(this.$route.query) != '{}' && this.$route.query.depthbomb_id != 'undefined' && this.$route.query.depthbomb_id != undefined){
            this.depthbomb_id = this.$route.query.depthbomb_id
        }
        this.getData()
    }
}
</script>
<style lang="scss" scoped>
.recordWrap{
    width: 100%;
    flex: 1;
    // padding-top: .9rem;
    // box-sizing: border-box;
}

.recordHeader{
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
}

.record_content{
    width: 100%;

    &>.record_list:nth-last-child(1){
        border:none;
    }
}

.record_list{
    width: 100%;
    display: flex;
    align-items: center;
    padding: .3rem;
    border-bottom: .01rem solid #f6f6f6;
    box-sizing: border-box;
}

.record_msg{
    margin-left: .16rem;

    &>h3{
        font-size: .3rem;
        color: #333;
    }

    &>p{
        color: #666;
        margin-top: .1rem;
    }
}

.list_left{
    flex: 1;
    display: flex;
    align-items: center;
}

.record_img{
    width: .8rem;
    height: .8rem;
    border-radius: 50%;
    overflow: hidden;
    background: #ccc;

    img{
        width: 100%;
        height: 100%;
    }
}

.list_right{
    flex-shrink: 0;
    padding-left :.2rem;
    box-sizing: border-box;
}

.list_right>i{
    font-size: .36rem;
    color: #666;
}

.list_right>i:nth-child(1){
    margin-right: .4rem;
}

.isTop{
    color: #e05559!important;
}

.list_right>i:nth-child(2){
    color: #666;
}
</style>